import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DemoDataStatus } from "models/demo-data";

export interface DemoDataSliceState {
    status: DemoDataStatus | null;
    // True once the status request finished (even if it failed), so it is asked only once.
    loaded: boolean;
}

export const initialState: DemoDataSliceState = {
    status: null,
    loaded: false,
};

const DemoDataSlice = createSlice({
    name: "demo-data-slice",
    initialState,
    reducers: {
        setDemoDataStatus(state, { payload }: PayloadAction<DemoDataStatus | null>) {
            state.status = payload;
            state.loaded = true;
        },
    },
});

export const { setDemoDataStatus } = DemoDataSlice.actions;

export default DemoDataSlice.reducer;
